export default "__VITE_ASSET__Cq9sXyy4__"